export const VideoIframe = ({ url }: { url: string }) => (
  // eslint-disable-next-line react/self-closing-comp
  <iframe
    width="560"
    height="315"
    src={url}
    title="YouTube video player"
    allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
)
